import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import BlanksInput from "@/components/blanksInput/BlanksInput.vue";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import { Events } from "@/events/events";
import quizUtils from "@/util/quizUtils";
let FillInTheBlanksQuestionEdit = class FillInTheBlanksQuestionEdit extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "questionId", void 0);
    _defineProperty(this, "question", null);
  }
  mounted() {
    this.loadQuestionData();
  }
  get blanksData() {
    if (this.question && this.question.blanks?.length > 0) {
      const blanks = this.question.blanks.map(blank => ({
        id: blank.id,
        position: blank.position,
        type: blank.type,
        responses: blank.responses?.map(response => ({
          label: response.label,
          type: response.type,
          correctAnswer: response.correctAnswer,
          caseSensitive: response.caseSensitive,
          image: response.image
        })) || []
      }));
      return {
        text: this.question.blanksText,
        blanks: blanks
      };
    } else {
      return {
        text: '',
        blanks: []
      };
    }
  }
  /**
   * load question data by the questionId
   * @private
   */
  loadQuestionData() {
    axios.get(`${quizUtils.QUIZ_QUESTION_BASE_API}/${this.questionId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => this.question = response.data).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
  /**
   * on blanks input update, save the data
   */
  onBlanksInputUpdate(blanksData) {
    axios.put(`${quizUtils.QUIZ_QUESTION_BASE_API}/${this.questionId}/blanks-data`, {
      blanksDataJson: JSON.stringify(blanksData)
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      WElMessage.showSuccessMessage(this.$t('chapter.question.answerModification.success'));
      trig(Events.NEW_KIND_OF_QUESTION_UPDATED, {
        chapterId: this.chapterId,
        questionId: this.questionId
      });
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
};
__decorate([Prop({
  required: true
})], FillInTheBlanksQuestionEdit.prototype, "chapterId", void 0);
__decorate([Prop({
  required: true
})], FillInTheBlanksQuestionEdit.prototype, "questionId", void 0);
FillInTheBlanksQuestionEdit = __decorate([Component({
  components: {
    BlanksInput
  }
})], FillInTheBlanksQuestionEdit);
export default FillInTheBlanksQuestionEdit;